import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GbgrundstueckService } from '../../../core/gb-api';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { GrundstueckBeschreibungComponent } from '../../beschreibung/grundstueck-beschreibung.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-beschreibung-rubrik',
  templateUrl: './grundstueckbeschreibung-rubrik.component.html',
  styleUrls: ['./grundstueckbeschreibung-rubrik.component.scss'],
  imports: [RubrikComponent, GrundstueckBeschreibungComponent, TranslatePipe]
})
export class GrundstueckbeschreibungRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected loadData() {}
}
